import { styled } from 'styled-components'

export const Divider = styled.hr`
    background-color: ${(p) => p.theme.colors.tertiary.tertiary200};
    height: 1px;
    width: 100%;
    margin: 8px 0;
    border: none;
`
